// extracted by mini-css-extract-plugin
export default {"wrapper":"EOcI6K","label":"a49Azy","defaultText":"mtP_xB","hoverText":"d2f0a8","labelText":"oNqFzH"};